import { useTranslation } from "react-i18next";
import { Column, Row } from "@/ui-kit";
import { DatePickerControl, FileInputControl, InputControl } from "@/controls";

type IProps = {
  color?: "layer1" | "layer2";
};

export const LicenseForm = ({ color = "layer2" }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <InputControl
        label={t("label.license_number")}
        name="licenseIdNumber"
        color={color}
      />

      <Row gap={16} alignmentVertical="top">
        <Column fullWidth>
          <DatePickerControl
            label={t("label.issuance_date")}
            name="licenseIdIssuanceDate"
            maxDate={new Date()}
            color={color}
          />
        </Column>
        <Column fullWidth>
          <DatePickerControl
            label={t("label.expiry_date")}
            name="licenseIdExpiryDate"
            minDate={new Date()}
            color={color}
          />
        </Column>
      </Row>

      <FileInputControl
        label={t("label.license_front_image")}
        name="licenseFrontPicture"
        variant={color}
      />

      <FileInputControl
        label={t("label.license_back_image")}
        name="licenseBackPicture"
        variant={color}
      />
    </>
  );
};
